document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".wheel-offset-link");
  if (!links.length) return;

  const current = window.location.pathname.split("/").pop();

  function clearActive() {
    links.forEach(l => l.classList.remove("active"));
  }

  // URL-based active
  links.forEach(link => {
    const handle = link.dataset.url;

    if (handle === current) {
      clearActive();
      link.classList.add("active");
    }

    // CLICK EVENT
    link.addEventListener("click", () => {
      clearActive();
      link.classList.add("active");
      localStorage.setItem("selectedWheelOffset", handle);
    });
  });

  // LocalStorage restoration
  const stored = localStorage.getItem("selectedWheelOffset");
  if (stored) {
    links.forEach(link => {
      if (link.dataset.url === stored) {
        clearActive();
        link.classList.add("active");
      }
    });
  }
});
